export default __webpack_public_path__ + "static/media/warning--winding-road--g1.f80521c5.png";